/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseRegimentCultureinfoQueryResponse>;
